import i18n from 'i18next';

import { planKeys } from 'config/planKeys';
import {
    FORM_PSYCHO_QUIZ,
    FORM_QUIZ,
    FORM_SURVEY,
    FORM_LOTTERY_GAME,
    FORM_VOTE,
    FORM_INVOICE
} from 'config/formTypes';
import * as lotteryTypes from 'config/promoLotteryTypes';

/**
 * Game 類型
 *
 * - 2: 心理測驗 (formbased)
 * - 7: 登錄給獎 (空 formbased)
 * - 5: 問答小學堂 (formbased)
 * - 6: 問卷調查 (formbased)
 * - 8: 大輪盤 (空 formbased + 純獎)
 * - 9: 議題投票 (formbased)
 * - 10: 戳戳樂 (空 formbased + 純獎)
 * - 11: 刮刮卡 (空 formbased + 純獎)
 * - 12: 發票 (formbased)
 * - 13: 紅包雨 (空 formbased + 純獎)
 * - 14: 圖片上傳 (ugc)
 * - 15: 簽到模組
 * - 16: 徵圖比賽 (投票 + ugc 14)
 * - 17: 創意相框 (ugc)
 * - 18: 拉霸 (空 formbased + 純獎)
 * - 19: 自由選
 * - 20: 翻牌遊戲
 * - 21: 留言模組 (ugc)
 * - 22: 票選比賽 (投票 + admin 上稿 ugc 14 / ugc 25)
 * - 23: 圖片闖關
 * - 24: 相框合成比賽 (投票 + ugc 17)
 * - 25: 影片上傳 (ugc)
 * - 26: 徵片比賽 (投票 + ugc 25)
 * - 27: IG 模組
 * - 28: 發票 v4.0
 * - 32: 點數兌獎
 * - 33: 邀請好友任務
 * - 35: 新客加入獎勵
 * - 36: 多元任務模組
 * - 37: 訂單模組
 * - 38: 購物車模組
 * - 39: 任務登錄派獎
 */
export const gameTypes = {
    PSYCHO_QUIZ: 2,
    SIGN_FORM: 7,
    QUIZ: 5,
    SURVEY: 6,
    WIN_WHEEL: 8,
    VOTE: 9,
    POKE_GAME: 10,
    SCRATCH_CARD: 11,
    INVOICE: 12,
    RED_ENVELOPE_RAIN: 13,
    PHOTO_UPLOAD: 14,
    CHECK_IN: 15,
    CONTEST_PHOTO_UPLOAD: 16,
    PHOTO_FRAME_COMPOSITE: 17,
    SLOTS: 18,
    PICK_THE_PRIZE: 19,
    MEMORY_MATCH: 20,
    COMMENT: 21,
    CONTEST_ADMIN_UPLOAD: 22,
    CHALLENGE_PHOTO_FRAME_COMPOSITE: 23,
    CONTEST_PHOTO_FRAME_COMPOSITE: 24,
    VIDEO_UPLOAD: 25,
    CONTEST_VIDEO_UPLOAD: 26,
    INSTAGRAM: 27,
    PURCHASE_REWARD: 28,
    POINTS_REDEEM: 32,
    MGM_SHARE: 33,
    MGM_REFERRAL: 34,
    SIGN_UP: 35,
    MULTI_CHALLENGE: 36,
    ORDER_REWARD: 37,
    CART_REWARD: 38,
    MISSION_REWARD_BY_STAFF: 39
};

export const pureGameTypeMappingLotteryType = {
    [gameTypes.SCRATCH_CARD]: lotteryTypes.SCRATCH_CARD,
    [gameTypes.WIN_WHEEL]: lotteryTypes.WIN_WHEEL,
    [gameTypes.POKE_GAME]: lotteryTypes.POKE_GAME,
    [gameTypes.RED_ENVELOPE_RAIN]: lotteryTypes.RED_ENVELOPE_RAIN,
    [gameTypes.SLOTS]: lotteryTypes.SLOTS,
    [gameTypes.PICK_THE_PRIZE]: lotteryTypes.PICK_THE_PRIZE,
    [gameTypes.POINTS_REDEEM]: lotteryTypes.POINTS_REDEEM
};

export const gamesConfig = {
    PSYCHO_QUIZ: {
        type: gameTypes.PSYCHO_QUIZ,
        planKey: planKeys.modules.PSYCHO_QUIZ,
        formBasedType: FORM_PSYCHO_QUIZ,
        i18nNameKey: 'label.game_type_psycho_quiz',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_psychological_test.png',
        descriptionText: 'label.psycho_quiz.description_text',
        moduleNameForWebhook: 'personalityQuiz',
        hasRelatedPromoOptions: true
    },
    SIGN_FORM: {
        type: gameTypes.SIGN_FORM,
        planKey: planKeys.modules.SIGN_FORM,
        formBasedType: FORM_LOTTERY_GAME,
        i18nNameKey: 'label.game_type_signup_form',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_sign_form.png',
        descriptionText: 'label.sign_form.description_text',
        moduleNameForWebhook: 'enterToWin'
    },
    QUIZ: {
        type: gameTypes.QUIZ,
        planKey: planKeys.modules.QUIZ,
        formBasedType: FORM_QUIZ,
        i18nNameKey: 'label.game_type_quiz',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_quiz.png',
        descriptionText: 'label.quiz.description_text',
        moduleNameForWebhook: 'qaQuiz'
    },
    SURVEY: {
        type: gameTypes.SURVEY,
        planKey: planKeys.modules.SURVEY,
        formBasedType: FORM_SURVEY,
        i18nNameKey: 'label.game_type_survey',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_survey.png',
        descriptionText: 'label.survey.description_text',
        moduleNameForWebhook: 'survey'
    },
    WIN_WHEEL: {
        type: gameTypes.WIN_WHEEL,
        planKey: planKeys.modules.WIN_WHEEL,
        formBasedType: FORM_LOTTERY_GAME,
        purePrizeGameLotteryType: lotteryTypes.WIN_WHEEL,
        i18nNameKey: 'label.game_type_winwheel',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_winwheel.png',
        descriptionText: 'label.win_wheel.description_text',
        moduleNameForWebhook: 'luckyWheel',
        isPurePrizeGame: true
    },
    VOTE: {
        type: gameTypes.VOTE,
        planKey: planKeys.modules.VOTE,
        formBasedType: FORM_VOTE,
        i18nNameKey: 'label.game_type_vote',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_vote.png',
        descriptionText: 'label.vote.description_text',
        moduleNameForWebhook: 'poll'
    },
    POKE_GAME: {
        type: gameTypes.POKE_GAME,
        planKey: planKeys.modules.POKE_GAME,
        formBasedType: FORM_LOTTERY_GAME,
        purePrizeGameLotteryType: lotteryTypes.POKE_GAME,
        i18nNameKey: 'label.game_type_poke_game',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_poke_game.png',
        descriptionText: 'label.poke_game.description_text',
        moduleNameForWebhook: 'pokeAPrize',
        isPurePrizeGame: true
    },
    SCRATCH_CARD: {
        type: gameTypes.SCRATCH_CARD,
        planKey: planKeys.modules.SCRATCH_CARD,
        formBasedType: FORM_LOTTERY_GAME,
        purePrizeGameLotteryType: lotteryTypes.POKE_GAME,
        i18nNameKey: 'label.game_type_scratch_card',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_scratch_card.png',
        descriptionText: 'label.scratch_card.description_text',
        moduleNameForWebhook: 'scratchCards',
        isPurePrizeGame: true
    },
    INVOICE: {
        type: gameTypes.INVOICE,
        planKey: planKeys.modules.INVOICE,
        formBasedType: FORM_INVOICE,
        i18nNameKey: 'label.game_type_invoice',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_invoice.png',
        descriptionText: 'label.invoice.description_text',
        moduleNameForWebhook: 'purchaseToWin'
    },
    RED_ENVELOPE_RAIN: {
        type: gameTypes.RED_ENVELOPE_RAIN,
        planKey: planKeys.modules.RED_ENVELOPE_RAIN,
        formBasedType: FORM_LOTTERY_GAME,
        purePrizeGameLotteryType: lotteryTypes.RED_ENVELOPE_RAIN,
        i18nNameKey: 'label.red_envelope_rain',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_red_envelope_rain.png',
        descriptionText: 'label.red_envelope_rain.description_text',
        moduleNameForWebhook: 'prizeShower',
        isPurePrizeGame: true
    },
    PHOTO_UPLOAD: {
        type: gameTypes.PHOTO_UPLOAD,
        planKey: planKeys.modules.PHOTO_UPLOAD,
        i18nNameKey: 'label.game_type_photo_upload',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_photo_upload.png',
        descriptionText: 'label.photo_upload.description_text',
        moduleNameForWebhook: 'photoUpload',
        isUgcGame: true,
        canLinkWithContestModule: true
    },
    CHECK_IN: {
        type: gameTypes.CHECK_IN,
        planKey: planKeys.modules.CHECK_IN,
        i18nNameKey: 'label.game_type_check_in',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_check_in.png',
        descriptionText: 'label.check_in.description_text',
        moduleNameForWebhook: 'checkIn'
    },
    CONTEST_PHOTO_UPLOAD: {
        type: gameTypes.CONTEST_PHOTO_UPLOAD,
        planKey: planKeys.modules.CONTEST_PHOTO_UPLOAD,
        i18nNameKey: 'label.game_type_photo_contest',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_photo_contest.png',
        descriptionText: 'label.contest_photo_upload.description_text',
        moduleNameForWebhook: 'photoContest',
        hasUgcFlow: true,
        ugcLinkKeys: [planKeys.modules.PHOTO_UPLOAD]
    },
    PHOTO_FRAME_COMPOSITE: {
        type: gameTypes.PHOTO_FRAME_COMPOSITE,
        planKey: planKeys.modules.PHOTO_FRAME_COMPOSITE,
        i18nNameKey: 'label.game_type_photo_frame_composite',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_photo_composite.png',
        descriptionText: 'label.photo_frame_composite.description_text',
        moduleNameForWebhook: 'creativeFrame',
        hasRelatedPromoOptions: true,
        isUgcGame: true,
        canLinkWithContestModule: true
    },
    SLOTS: {
        type: gameTypes.SLOTS,
        planKey: planKeys.modules.SLOTS,
        formBasedType: FORM_LOTTERY_GAME,
        purePrizeGameLotteryType: lotteryTypes.SLOTS,
        i18nNameKey: 'label.slots',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_slots.png',
        descriptionText: 'label.slots.description_text',
        moduleNameForWebhook: 'slot',
        isPurePrizeGame: true
    },
    PICK_THE_PRIZE: {
        type: gameTypes.PICK_THE_PRIZE,
        planKey: planKeys.modules.PICK_THE_PRIZE,
        formBasedType: FORM_LOTTERY_GAME,
        purePrizeGameLotteryType: lotteryTypes.PICK_THE_PRIZE,
        i18nNameKey: 'label.game_type_pick_the_prize',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_choose.png',
        descriptionText: 'label.pick_the_prize.description_text',
        moduleNameForWebhook: 'pickThePrize',
        isPurePrizeGame: true
    },
    MEMORY_MATCH: {
        type: gameTypes.MEMORY_MATCH,
        planKey: planKeys.modules.MEMORY_MATCH,
        i18nNameKey: 'label.memoryMatch',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_memory_match.png',
        descriptionText: 'label.memory_match.description_text',
        moduleNameForWebhook: 'memoryMatch',
        hasRelatedPromoOptions: true
    },
    COMMENT: {
        type: gameTypes.COMMENT,
        planKey: planKeys.modules.COMMENT,
        i18nNameKey: 'label.game_type_comment',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_comment.png',
        descriptionText: 'label.comment.description_text',
        moduleNameForWebhook: 'comment',
        hasRelatedPromoOptions: true,
        isUgcGame: true
    },
    CONTEST_ADMIN_UPLOAD: {
        type: gameTypes.CONTEST_ADMIN_UPLOAD,
        planKey: planKeys.modules.CONTEST_ADMIN_UPLOAD,
        i18nNameKey: 'label.game_type_voting_contest',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_voting_contest.png',
        descriptionText: 'label.contest_admin_upload.description_text',
        moduleNameForWebhook: 'votingContest',
        hasUgcFlow: false,
        ugcLinkKeys: [planKeys.modules.PHOTO_UPLOAD, planKeys.modules.VIDEO_UPLOAD]
    },
    CONTEST_PHOTO_FRAME_COMPOSITE: {
        type: gameTypes.CONTEST_PHOTO_FRAME_COMPOSITE,
        planKey: planKeys.modules.CONTEST_PHOTO_FRAME_COMPOSITE,
        i18nNameKey: 'label.game_type_frame_composite_contest',
        imageSrc:
            'https://assets.fevercdn.com/nc-admin/images/promo_module_frame_composite_contest.png',
        descriptionText: 'label.contest_photo_frame_composite.description_text',
        moduleNameForWebhook: 'framedPhotoContest',
        hasUgcFlow: true,
        ugcLinkKeys: [planKeys.modules.PHOTO_FRAME_COMPOSITE]
    },
    CHALLENGE_PHOTO_FRAME_COMPOSITE: {
        type: gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE,
        planKey: planKeys.modules.CHALLENGE_PHOTO_FRAME_COMPOSITE,
        i18nNameKey: 'label.game_type_challenge_photo_frame_composite',
        imageSrc:
            'https://assets.fevercdn.com/nc-admin/images/promo_module_challenge_photo_composite.png',
        descriptionText: 'label.challenge_photo_frame_composite.description_text',
        moduleNameForWebhook: 'photoChallenge',
        hasRelatedPromoOptions: true,
        hasRelatedPromoTask: true,
        isUgcGame: true
    },
    VIDEO_UPLOAD: {
        type: gameTypes.VIDEO_UPLOAD,
        planKey: planKeys.modules.VIDEO_UPLOAD,
        i18nNameKey: 'label.game_type_video_upload',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_video_upload.png',
        descriptionText: 'label.video_upload.description_text',
        moduleNameForWebhook: 'videoUpload',
        isUgcGame: true,
        canLinkWithContestModule: true
    },
    CONTEST_VIDEO_UPLOAD: {
        type: gameTypes.CONTEST_VIDEO_UPLOAD,
        planKey: planKeys.modules.CONTEST_VIDEO_UPLOAD,
        i18nNameKey: 'label.game_type_video_contest',
        imageSrc:
            'https://assets.fevercdn.com/nc-admin/images/promo_module_contest_video_upload.png',
        descriptionText: 'label.contest_video_upload.description_text',
        moduleNameForWebhook: 'videoContest',
        hasUgcFlow: true,
        ugcLinkKeys: [planKeys.modules.VIDEO_UPLOAD]
    },
    INSTAGRAM: {
        type: gameTypes.INSTAGRAM,
        planKey: 'promotionInstagram',
        i18nNameKey: 'label.game_type_instagram',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_instagram_module.png',
        descriptionText: 'label.instagram.description_text',
        moduleNameForWebhook: 'instagram',
        isUgcGame: true
    },
    PURCHASE_REWARD: {
        type: gameTypes.PURCHASE_REWARD,
        planKey: planKeys.modules.PURCHASE_REWARD,
        hasRelatedPromoOptions: true,
        i18nNameKey: 'label.game_type_purchase_reward',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_invoice.png',
        descriptionText: 'label.purchase_reward.description_text',
        moduleNameForWebhook: 'purchaseReward'
    },
    POINTS_REDEEM: {
        type: gameTypes.POINTS_REDEEM,
        planKey: planKeys.modules.POINTS_REDEEM,
        i18nNameKey: 'label.game_type_points_redeem',
        purePrizeGameLotteryType: lotteryTypes.POINTS_REDEEM,
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_points_redeem.svg',
        descriptionText: 'label.points_redeem.description_text',
        moduleNameForWebhook: 'pointsRedeem',
        isPurePrizeGame: true
    },
    MGM_SHARE: {
        type: gameTypes.MGM_SHARE,
        planKey: planKeys.modules.MGM_SHARE,
        i18nNameKey: 'label.game_type_mgm_share',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_refer_a_friend.svg',
        descriptionText: 'label.mgm_share.description_text',
        moduleNameForWebhook: 'mgmShare'
    },
    SIGN_UP: {
        type: gameTypes.SIGN_UP,
        planKey: planKeys.modules.SIGN_UP,
        i18nNameKey: 'label.game_type_sign_up',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_sign_up_reward.svg',
        descriptionText: 'label.sign_up.description_text',
        moduleNameForWebhook: 'signUp'
    },
    MULTI_CHALLENGE: {
        type: gameTypes.MULTI_CHALLENGE,
        planKey: planKeys.modules.MULTI_CHALLENGE,
        i18nNameKey: 'label.game_type_multi_challenge',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_sign_up_reward.svg',
        descriptionText: 'label.multi_challenge.description_text',
        hasRelatedPromoTask: true,
        moduleNameForWebhook: 'multiChallenge'
    },
    ORDER_REWARD: {
        type: gameTypes.ORDER_REWARD,
        planKey: planKeys.modules.ORDER_REWARD,
        hasRelatedPromoOptions: true,
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_order_reward.png',
        descriptionText: 'label.order_reward.description_text',
        i18nNameKey: 'label.game_type_order_reward',
        moduleNameForWebhook: 'orderReward'
    },
    CART_REWARD: {
        type: gameTypes.CART_REWARD,
        planKey: planKeys.modules.CART_REWARD,
        hasRelatedPromoOptions: true,
        i18nNameKey: 'label.game_type_cart_reward',
        imageSrc: 'https://assets.fevercdn.com/nc-admin/images/promo_module_cart_reward.png',
        descriptionText: 'label.cart_reward.description_text',
        moduleNameForWebhook: 'addToCart'
    },
    MISSION_REWARD_BY_STAFF: {
        type: gameTypes.MISSION_REWARD_BY_STAFF,
        planKey: planKeys.modules.MISSION_REWARD_BY_STAFF,
        hasRelatedPromoOptions: true,
        i18nNameKey: 'label.game_type_mission_reward_by_staff',
        imageSrc:
            'https://assets.fevercdn.com/nc-admin/images/promo_module_missionRewardByStaff.png',
        moduleNameForWebhook: 'missionRewardByStaff'
    }
};

const gameTypeImageSrc = Object.entries(gamesConfig).reduce((obj, [, { type, imageSrc }]) => {
    obj[type] = imageSrc;
    return obj;
}, {});

export function getGameTypeImageSrc(gameType) {
    const imageSrc = gameTypeImageSrc[gameType];
    return Boolean(imageSrc) ? imageSrc : '';
}

const gameTypeNames = Object.entries(gamesConfig).reduce((obj, [, { type, i18nNameKey }]) => {
    obj[type] = i18nNameKey;
    return obj;
}, {});

export function getGameTypeLabel(gameType, t = (...args) => i18n.t(...args)) {
    const i18nKey = gameTypeNames[gameType];
    return Boolean(i18nKey) ? t(i18nKey) : '';
}

const gameTypePlanKeys = Object.entries(gamesConfig).reduce((obj, [, { type, planKey }]) => {
    obj[type] = planKey;
    return obj;
}, {});

export function getGamePlanKey(gameType) {
    const planKey = gameTypePlanKeys[gameType];
    return Boolean(planKey) ? planKey : '';
}

const gameTypeModuleNames = Object.entries(gamesConfig).reduce(
    (obj, [, { type, moduleNameForWebhook }]) => {
        obj[type] = moduleNameForWebhook;
        return obj;
    },
    {}
);
export function getGameTypeModuleName(gameType) {
    const moduleNameForWebhook = gameTypeModuleNames[gameType];
    return Boolean(moduleNameForWebhook) ? moduleNameForWebhook : '';
}

const formbasedGames = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, formBasedType }]) => (formBasedType !== undefined ? type : undefined))
        .filter(t => t !== undefined)
]);
export function isFormBasedGame(gameType) {
    return formbasedGames.has(gameType);
}

const purePrizeGames = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, isPurePrizeGame }]) => (isPurePrizeGame ? type : undefined))
        .filter(t => t !== undefined)
]);
export function isPurePrizeGames(gameType) {
    return purePrizeGames.has(gameType);
}

const ugcGames = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, isUgcGame }]) => (isUgcGame ? type : undefined))
        .filter(t => t !== undefined)
]);
export function isUgcGames(gameType) {
    return ugcGames.has(gameType);
}

const hasPromoTaskGames = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, hasRelatedPromoTask }]) => (hasRelatedPromoTask ? type : undefined))
        .filter(t => t !== undefined)
]);
export function checkIsGameHasPromoTask(gameType) {
    return hasPromoTaskGames.has(gameType);
}

const hasPromoOptionGames = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, hasRelatedPromoOptions }]) => (hasRelatedPromoOptions ? type : undefined))
        .filter(t => t !== undefined)
]);
export function checkIsGameHasPromoOptions(gameType) {
    return hasPromoOptionGames.has(gameType);
}

export const contestGamesForUserPlayableUgc = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, ugcLinkKeys, hasUgcFlow }]) =>
            Array.isArray(ugcLinkKeys) && hasUgcFlow ? type : undefined
        )
        .filter(t => t !== undefined)
]);
export function isContestGamesForUserPlayableUgc(gameType) {
    return contestGamesForUserPlayableUgc.has(gameType);
}

const contestGamesWithSecondaryUgc = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, ugcLinkKeys }]) => (Array.isArray(ugcLinkKeys) ? type : undefined))
        .filter(t => t !== undefined)
]);
export function isContestGamesWithSecondaryUgc(gameType) {
    return isContestGamesForUserPlayableUgc(gameType) || contestGamesWithSecondaryUgc.has(gameType);
}

export const ugcGamesCanLinkWithContestModule = new Set([
    ...Object.entries(gamesConfig)
        .map(([, { type, canLinkWithContestModule }]) =>
            canLinkWithContestModule ? type : undefined
        )
        .filter(t => t !== undefined)
]);

// 模組可進入作品集、作品頁頁面
export function isUgcGameAndHasUgcMediaFlow(gameType) {
    return gameType !== gameTypes.COMMENT && isUgcGames(gameType);
}

//特殊需求模組列表（純獎模組 & 問券模組外 要使用960px的寬度）
const smallPromoWidthGames = new Set([gameTypes.SURVEY]);
export function isSmallPromoWidth(gameType) {
    return isPurePrizeGames(gameType) || smallPromoWidthGames.has(gameType);
}

// 比賽搭配 ugc 雙模組的情況下，promo settings 裡會用該 key 存放關聯的 ugc 的 promoUUID
const ugcLinkedKeysInContestModule = Object.entries(gamesConfig).reduce(
    (obj, [moduleKey, { canLinkWithContestModule, planKey }]) => {
        if (canLinkWithContestModule) {
            obj[moduleKey] = planKey;
        }
        return obj;
    },
    {}
);
export const ugcLinkedKeysInContestModuleSet = new Set([
    ...Object.values(ugcLinkedKeysInContestModule)
]);

const contestModuleMappingUsableUgcLinkKeys = Object.entries(gamesConfig).reduce(
    (obj, [, { type, ugcLinkKeys }]) => {
        if (Array.isArray(ugcLinkKeys)) {
            obj[type] = ugcLinkKeys;
        }
        return obj;
    },
    {}
);
export function contestGetUgcLinkKey(gameType, settingPromo) {
    const usableUgcLinkKeys = contestModuleMappingUsableUgcLinkKeys[gameType] ?? [];
    const [ugcLinkKey] =
        Object.entries(settingPromo).find(([key]) => usableUgcLinkKeys.includes(key)) ?? [];

    return ugcLinkKey;
}

//  符合獎品相關設定頁籤 - 點數計算規則
const pointCountRuleGames = new Set([
    gameTypes.PURCHASE_REWARD,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD
]);
export function hasPointCountRuleGames(gameType) {
    return pointCountRuleGames.has(gameType);
}

// 是否要呈現出獎品相關設定頁籤
export function hasShowPointRelatedSettingTab(gameType) {
    return hasPointCountRuleGames(gameType);
}

//  符合獎品類型動態計算 （ 會員點數 )
const dynamicPrizeTypeGames = new Set([
    gameTypes.PURCHASE_REWARD,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD,
    gameTypes.MISSION_REWARD_BY_STAFF
]);
export function hasShowDynamicCountPrizeType(gameType) {
    return dynamicPrizeTypeGames.has(gameType);
}

// 跳過 Checker 的登入檢查
const passLoginCheckTrigger = new Set([gameTypes.SIGN_UP]);
export function hasPassLoginCheckTriggerGame(gameType) {
    return passLoginCheckTrigger.has(gameType);
}

// 隱藏獎品發完處理方式設定 ( 邀請模組要隱藏，但目前獎品區塊使用 mgm reduxt ，因此透過 MGM_REFERRAL 設定 )
const hideSettingPromoWhenNoPrizeGames = new Set([gameTypes.MGM_SHARE, gameTypes.MGM_REFERRAL]);
export function hasHideSettingPromoWhenNoPrizeGames(gameType) {
    return hideSettingPromoWhenNoPrizeGames.has(gameType);
}

export const promoFormTemplateMapping = Object.entries(gamesConfig).reduce(
    (obj, [, { type, formBasedType }]) => {
        if (formBasedType !== undefined) {
            obj[type] = formBasedType;
        }
        return obj;
    },
    {}
);

export const promoLotteryTemplateMapping = Object.entries(gamesConfig).reduce(
    (obj, [, { type, purePrizeGameLotteryType }]) => {
        if (purePrizeGameLotteryType !== undefined) {
            obj[type] = purePrizeGameLotteryType;
        }
        return obj;
    },
    {}
);

// 不開放標籤設定 [目前僅有 ig]
const canNotUseTags = new Set([gameTypes.INSTAGRAM]);
export function isCanNotUseTags(gameType) {
    return canNotUseTags.has(gameType);
}

// 可以設定 Promotion 審核機制模組
const canSetVerifyMechanismGames = new Set([
    gameTypes.INVOICE,
    gameTypes.PURCHASE_REWARD,
    gameTypes.SIGN_UP,
    gameTypes.PSYCHO_QUIZ,
    gameTypes.QUIZ,
    gameTypes.SURVEY,
    gameTypes.SIGN_FORM,
    gameTypes.VOTE,
    gameTypes.CHECK_IN,
    gameTypes.MEMORY_MATCH,
    gameTypes.MULTI_CHALLENGE,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD,
    gameTypes.MISSION_REWARD_BY_STAFF
]);
export function isCanSetVerifyMechanismGames(gameType) {
    return canSetVerifyMechanismGames.has(gameType) || isUgcGames(gameType);
}

// 強制開啟 Promotion 審核機制模組
const hasForceVerifyMechanismGames = new Set([
    gameTypes.PURCHASE_REWARD,
    gameTypes.SIGN_UP,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD,
    gameTypes.MISSION_REWARD_BY_STAFF
]);
export function isForceVerifyMechanismGames(gameType) {
    return hasForceVerifyMechanismGames.has(gameType) || isUgcGames(gameType);
}
// 有特別審核機制的模組
const hasSpecialVerificationGames = new Set([
    gameTypes.PURCHASE_REWARD,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD,
    gameTypes.MISSION_REWARD_BY_STAFF
]);
export function isSpecialVerificationGames(gameType) {
    return hasSpecialVerificationGames.has(gameType);
}

// 流程進行導轉時若發現有 unOpenWinnerPrize ，進行開獎後在導轉
const hasAutoTriggerAnimationGames = new Set([gameTypes.PICK_THE_PRIZE, gameTypes.POINTS_REDEEM]);
export function isAutoTriggerAnimationGames(gameType) {
    return hasAutoTriggerAnimationGames.has(gameType);
}

//  可以開啟全對才能獲獎-給獎資格
const canSetAllCorrectGetPrizeRuleGames = new Set([gameTypes.MEMORY_MATCH, gameTypes.QUIZ]);
export function isCanSetAllCorrectGetPrizeRuleGames(gameType) {
    return canSetAllCorrectGetPrizeRuleGames.has(gameType);
}

// 需要有會員登入的活動
const hasNeedLoginEnterpriseGames = new Set([gameTypes.SIGN_UP]);
export function isNeedLoginEnterpriseGames(type) {
    return hasNeedLoginEnterpriseGames.has(type);
}

// 不可以跟多元任務模組關聯的活動 #86eq8hqf7
export const canNotRelateMultiChallengeTaskGames = new Set([
    gameTypes.INVOICE,
    gameTypes.CONTEST_PHOTO_UPLOAD,
    gameTypes.CONTEST_ADMIN_UPLOAD,
    gameTypes.CONTEST_PHOTO_FRAME_COMPOSITE,
    gameTypes.CONTEST_VIDEO_UPLOAD,
    gameTypes.INSTAGRAM,
    gameTypes.MULTI_CHALLENGE,
    gameTypes.SIGN_UP
]);

export function isCanRelateMultiChallengeTaskGames(type) {
    return !canNotRelateMultiChallengeTaskGames.has(type);
}

// gameResultRecords 要確認有沒有 lotteryParticipant 才成立
const checkGameResultRecordsHasLotteryParticipant = new Set([gameTypes.POINTS_REDEEM]);
export function isCheckGameResultRecordsHasLotteryParticipant(type) {
    return checkGameResultRecordsHasLotteryParticipant.has(type);
}

// 給獎規則可以顯示開啟鑑賞期後才能使用獎品
const canShowUseRevalidationGames = new Set([gameTypes.ORDER_REWARD, gameTypes.PURCHASE_REWARD]);
export function isCanShowUseRevalidationGames(type) {
    return canShowUseRevalidationGames.has(type);
}

//  可以開啟全對才能獲獎-給獎資格
const canSetTaskFilterGetPrizeRuleGames = new Set([
    gameTypes.PURCHASE_REWARD,
    gameTypes.ORDER_REWARD,
    gameTypes.CART_REWARD,
    gameTypes.MISSION_REWARD_BY_STAFF,
    gameTypes.PSYCHO_QUIZ
]);
export function isCanSetTaskFilterGetPrizeRuleGames(gameType) {
    return canSetTaskFilterGetPrizeRuleGames.has(gameType);
}
//含有coverPage的模組
const hasCoverPageGames = new Set([
    gameTypes.PSYCHO_QUIZ,
    gameTypes.QUIZ,
    gameTypes.SURVEY,
    gameTypes.SIGN_FORM,
    gameTypes.VOTE,
    gameTypes.CHECK_IN,
    gameTypes.PURCHASE_REWARD
]);
export function hasCoverPage(gameType) {
    return hasCoverPageGames.has(gameType);
}

//有客製化結果頁的模組
const hasCustomResultGames = new Set([gameTypes.PSYCHO_QUIZ, gameTypes.QUIZ]);

export function isCustomResultGames(gameType) {
    return hasCustomResultGames.has(gameType);
}

// 結果頁分類 ref:https://app.clickup.com/36226806/v/dc/12hhqp-33358
export const resultPageTypeAGames = new Set([
    gameTypes.SIGN_FORM,
    gameTypes.WIN_WHEEL,
    gameTypes.SCRATCH_CARD,
    gameTypes.POKE_GAME,
    gameTypes.RED_ENVELOPE_RAIN,
    gameTypes.SLOTS,
    gameTypes.PICK_THE_PRIZE
]);

export function isResultPageTypeA(gameType) {
    return resultPageTypeAGames.has(gameType);
}

//含有進度條的模組
export const hasProgressBarGames = new Set([gameTypes.QUIZ, gameTypes.PSYCHO_QUIZ, gameTypes.VOTE]);

export function isHasProgressBarGames(gameType) {
    return hasProgressBarGames.has(gameType);
}

export const enableBatchPublishGames = new Set([gameTypes.MULTI_CHALLENGE]);

export function isEnableBatchPublishGames(gameType) {
    return enableBatchPublishGames.has(gameType);
}
